import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.72 4.16L20.3 6.42V18.8L14.72 16.54L9.3 19.78L3.72 17.52V5.14L9.3 7.4L14.72 4.16ZM15.44 15.1L18.78 16.48V7.46L15.44 6.1V15.1ZM10.18 8.68V17.44L13.84 15.26V6.5L10.18 8.68ZM5.24 16.48L8.58 17.84V8.84L5.24 7.46V16.48Z" />
    </SvgIcon>
  );
});
